import {type ApiResult, apiSuccess, toApiFailure} from './ApiResult';
import type {Command, MethodBase} from './Command';

export class Client {
  constructor(private readonly apiName: string) {}

  /** Historique : rend la valeur, laisse remonter l'erreur Amplify telle quelle. */
  async send<M extends MethodBase, T>(command: Command<M, T>): Promise<T> {
    const result = command.method({...command.input, apiName: this.apiName});
    return await command.deserialize(result);
  }

  /**
   * Comme `send`, mais ne lève jamais : `{ok: true, value}` ou `{ok: false, code, message…}`
   * (cf. `ApiResult`). C'est la forme à préférer partout où l'utilisateur doit voir POURQUOI
   * une action a échoué — le code stable du serveur permet de proposer la bonne action.
   */
  async trySend<M extends MethodBase, T>(command: Command<M, T>): Promise<ApiResult<T>> {
    try {
      return apiSuccess(await this.send(command));
    } catch (error: unknown) {
      return await toApiFailure(error);
    }
  }
}
